import emotion.react.css
import kotlinx.browser.localStorage
import kotlinx.browser.window
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.label
import react.useState
import web.cssom.*
import web.html.InputType

external interface LoginProps : Props

val LoginPage = FC<LoginProps> {
    var phone by useState("")
    var status by useState("")
    var code by useState("")
    var isCode by useState(false)

    div {
        css {
            display = Display.flex
            flexDirection = FlexDirection.column
            alignItems = AlignItems.center
            justifyContent = JustifyContent.center
            minHeight = 98.vh
            width = 100.pct
        }
        div {
            css {
                borderRadius = 10.px
                padding = 20.px
                position = Position.fixed
                top = 50.pct
                transform = translate((-50).pct, (-50).pct)
                backgroundColor = rgb(142, 178, 170)
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center
                flexDirection = FlexDirection.column
                textAlign = TextAlign.center
                media(MediaQuery("(orientation: portrait)")) {
                    transform = scale(2)
                }
                media(MediaQuery("(orientation: landscape)")) {
                    left = 50.pct
                }
            }
            if (!isCode) {
                div {
                    css {
                        padding = 5.px
                        color = rgb(56, 246, 137)
                        fontSize = 22.px
                    }
                    +"Введите номер телефона:"
                }
                div {
                    css {
                        display = Display.flex
                        flexDirection = FlexDirection.row
                        alignItems = AlignItems.center
                        justifyContent = JustifyContent.center
                    }
                    label {
                        css {
                            marginRight = 5.px
                        }
                        +"+7"
                    }
                    input {
                        css {
                            marginTop = 5.px
                            marginBottom = 5.px
                            fontSize = 14.px
                        }
                        type = InputType.tel
                        onChange = {
                            phone = it.target.value
                        }
                    }
                }
                button {
                    css {
                        marginTop = 10.px
                        fontSize = 18.px
                    }
                    disabled = phone.length != 10
                    +"Отправить код"
                    onClick = {

                        window.fetch(urlAddress + "auth?phone=7$phone")
                            .then { response ->
                                if (response.ok) {
                                    isCode = true
                                } else {
                                    response.text().then {
                                        status = it
                                    }
                                }
                            }
                            .catch { error ->
                                status = "Ошибка при получении данных"
                                throw error
                            }
                    }
                }
                div {
                    css {
                        padding = 5.px
                        color = rgb(56, 246, 137)
                        fontSize = 18.px
                    }
                    +status
                }
            } else {
                div {
                    css {
                        padding = 5.px
                        color = rgb(56, 246, 137)
                        fontSize = 22.px
                    }
                    +"Введите проверчный код:"
                }
                div {
                    css {
                        display = Display.flex
                        flexDirection = FlexDirection.row
                        alignItems = AlignItems.center
                        justifyContent = JustifyContent.center
                    }
                    input {
                        css {
                            marginTop = 5.px
                            marginBottom = 5.px
                            fontSize = 14.px
                        }
                        type = InputType.tel
                        onChange = {
                            code = it.target.value
                        }
                    }
                }
                button {
                    css {
                        marginTop = 10.px
                        fontSize = 18.px
                    }
                    disabled = code.length != 4
                    +"Войти"

                    onClick = {
                        window.fetch(urlAddress + "login?phone=7$phone&code=$code")
                            .then { response ->
                                if (response.ok) {
                                    response.json()
                                } else {
                                    response.text().then {
                                        status = it
                                    }
                                }
                            }
                            .then { data ->
                                if (jsTypeOf(data) === "object") {
                                    localStorage.setItem("accessToken", data.asDynamic().token as String)
                                    window.location.reload()
                                } else {
                                    status = "Токен не найден в ответе"
                                }
                            }
                            .catch { error ->
                                status = "Не верный код"
                                throw error
                            }
                    }
                }
                div {
                    css {
                        padding = 5.px
                        color = rgb(56, 246, 137)
                        fontSize = 18.px
                    }
                    +status
                }
            }
        }
    }

}

